// extracted by mini-css-extract-plugin
export default {"main":"_404_main__ec5sJ","text":"_404_text__ek5o4","link":"_404_link__rOqD2"};